$(document).ready(function(){
    $(".js-form-date").datepicker({
        dateFormat: 'mm/dd/yy',
        changeMonth: true,
        changeYear: true,
        beforeShow: function(input, inst) {
            setTimeout(function() {
                $('#ui-datepicker-div').addClass('gravity-theme');
                $('#ui-datepicker-div').css('display', 'block');
            }, 0);
        }
    });
});
